import React, {useState} from 'react'
import './WikipediaSearch.css'

const WikipediaSearch = () => {
  const [searchInput, setSearchInput] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [loading, setLoading] = useState(false)

  const createAndAppendSearchResult = result => {
    const {link, title, description} = result

    return (
      <div className="result-item" key={link}>
        <a href={link} className="result-title">
          {title}
        </a>
        <br />
        <a href={link} className="result-url">
          {link}
        </a>
        <br />
        <p className="link-description">{description}</p>
      </div>
    )
  }

  const displayResults = results => {
    return results.map(result => createAndAppendSearchResult(result))
  }

  const searchWikipedia = () => {
    setLoading(true)
    setSearchResults([])

    const url = `https://apis.ccbp.in/wiki-search?search=${searchInput}`
    fetch(url)
      .then(response => response.json())
      .then(jsonData => {
        const {search_results} = jsonData
        setSearchResults(search_results)
        setLoading(false)
      })
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      searchWikipedia()
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
    searchWikipedia()
  }

  return (
    <div className="main-container">
      <div className="wiki-search-header">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Wikipedia_wordmark.svg/640px-Wikipedia_wordmark.svg.png"
          alt="Wikipedia Logo"
          className="wiki-logo"
        />
        <form onSubmit={handleSubmit}>
          <input
            className="search-input"
            id="searchInput"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="What do you aspire to discover today?"
          />
          <button type="submit" className="search-button">
            Submit
          </button>
        </form>
      </div>
      {loading && <div id="spinner">Loading...</div>}
      <div id="searchResults" className="search-results">
        {displayResults(searchResults)}
      </div>
    </div>
  )
}

export default WikipediaSearch
